// CacheKey d2cd878f6e3984f46b2fe68d44cb0787
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  zh: {
    date: {
      abbr_month_names: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      month_names: [
        null,
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日"
      ],
      formats: {
        default: "%d/%m/%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      pm: "pm",
      am: "am"
    },
    time_zones: {
      est: "东部时区",
      edt: "东部时区",
      cst: "中部时区",
      cdt: "中部时区",
      mst: "山区时区",
      mdt: "山区时区",
      pst: "太平洋时区",
      pdt: "太平洋时区",
      hst: "夏威夷－阿留申时区",
      hdt: "夏威夷－阿留申时区",
      akst: "阿拉斯加时区",
      akdt: "阿拉斯加时区"
    }
  }
}

